<template>
    <div v-show="visible">
        <el-dialog title="查看附件" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="600px">
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="200"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="附件">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileType == 1">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.url" lazy="loading"
                                    style="height:550px; width:550px"/>
                                <img slot="reference" :src="scope.row.url"  lazy="loading" :alt="scope.row.url" style="height: 100px;width:100px">
                            </el-popover>
                        </div>
                        <div v-else-if="scope.row.fileType == 3">
                            <el-button type="text" @click="lookVideo(scope.row)">点击查看视频</el-button>
                        </div>
                        <div v-else-if="scope.row.fileType == 2">
                            <a target="_blank" :href="scope.row.url">点击查看录音</a>
                        </div>
                        <div v-else-if="scope.row.fileType == 4">
                            <a target="_blank" :href="scope.row.url">进入链接</a>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
        <!--查看人脸视频 -->
        <div v-if="videoVisible">
            <lookVideo ref="lookVideo"></lookVideo>
        </div>
    </div>
</template>

<script>
    import http from '@/common/http';
    import lookVideo from '@/components/page/sys/user/Video';

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                videoVisible:false,
                form:{
                    patrolId:""
                },
                data:[]
            }
        },
        components: {
            lookVideo
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(id){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.patrolId=id

                this.getData();
            },
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.getFilesUrl;
                let data = {
                    patrolId:this.form.patrolId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    console.log(res.data);
                    if(res.status==200){
                       this.data = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            lookVideo(row){
                this.videoVisible = true;
                this.$nextTick(() => {
                    this.$refs['lookVideo'].init(row.url);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/patrol/fileInfo.vue